module.exports = __webpack_public_path__ + "static/media/brand-refresh-checked.d19b6e56.svg";